export default __webpack_public_path__ + "static/media/privacy_mobile.768620a9.png";